__turbopack_context__.v({
  "black": "index-module-scss-module__97mAqW__black",
  "blue": "index-module-scss-module__97mAqW__blue",
  "blue-green": "index-module-scss-module__97mAqW__blue-green",
  "button": "index-module-scss-module__97mAqW__button",
  "dark": "index-module-scss-module__97mAqW__dark",
  "full": "index-module-scss-module__97mAqW__full",
  "green": "index-module-scss-module__97mAqW__green",
  "grey": "index-module-scss-module__97mAqW__grey",
  "icon-left": "index-module-scss-module__97mAqW__icon-left",
  "icon-right": "index-module-scss-module__97mAqW__icon-right",
  "large": "index-module-scss-module__97mAqW__large",
  "light-grey": "index-module-scss-module__97mAqW__light-grey",
  "loading": "index-module-scss-module__97mAqW__loading",
  "loading-ellipse": "index-module-scss-module__97mAqW__loading-ellipse",
  "loading-ellipse1": "index-module-scss-module__97mAqW__loading-ellipse1",
  "loading-ellipse2": "index-module-scss-module__97mAqW__loading-ellipse2",
  "loading-ellipse3": "index-module-scss-module__97mAqW__loading-ellipse3",
  "normal": "index-module-scss-module__97mAqW__normal",
  "orange": "index-module-scss-module__97mAqW__orange",
  "outline": "index-module-scss-module__97mAqW__outline",
  "outline-round": "index-module-scss-module__97mAqW__outline-round",
  "red": "index-module-scss-module__97mAqW__red",
  "small": "index-module-scss-module__97mAqW__small",
  "solid": "index-module-scss-module__97mAqW__solid",
  "solid-round": "index-module-scss-module__97mAqW__solid-round",
  "text": "index-module-scss-module__97mAqW__text",
  "text-black": "index-module-scss-module__97mAqW__text-black",
  "text-simple": "index-module-scss-module__97mAqW__text-simple",
  "tooltips": "index-module-scss-module__97mAqW__tooltips",
  "urquoise-blue": "index-module-scss-module__97mAqW__urquoise-blue",
  "white": "index-module-scss-module__97mAqW__white",
  "with-icon": "index-module-scss-module__97mAqW__with-icon",
  "yellow": "index-module-scss-module__97mAqW__yellow",
});
